export class PaginationDecorator {
    constructor(original) {
        this._original = original;
    }
    defaultFromResponse(page) {
        if (!page.meta)
            throw new Error("Invalid pagination meta object");
        this._original.setMeta(page.meta.pagination);
        this._original.setObjects(Object.keys(page)
            .filter(key => key !== "meta")
            .map(key => Object.assign({}, { index: key }, page[key])));
        return this._original;
    }
    localFromResponse(page) {
        if (!page.meta)
            throw new Error("Invalid pagination meta object");
        this._original.setMeta(page.meta.pagination);
        const objects = new Array(page.meta.pagination.total);
        Object.keys(page)
            .filter(key => key !== "meta")
            .map(key => {
            objects[Number(key)] = Object.assign({}, { index: key }, page[key]);
        });
        this._original.setObjects(objects);
        return this._original;
    }
    localFromObjects(objects) {
        this._original.setObjects(objects.map((object, index) => ({ ...object, index })));
        this._original.setMeta({
            current_page: 1,
            per_page: this._original.getPerPage(),
            total_pages: Math.ceil(objects.length / this._original.getPerPage()),
            total: objects.length
        });
        return this._original;
    }
}
export class DefaultPagination {
    constructor(config) {
        this._objects = [];
        this._pageQuery = {
            page: 1,
            perPage: 10
        };
        if (config?.page)
            this._pageQuery.page = config.page;
        if (config?.perPage)
            this._pageQuery.perPage = config.perPage;
    }
    getAll() {
        return this._objects;
    }
    getTotal() {
        return this._meta?.total || 0;
    }
    getCurrentPage() {
        return this._pageQuery.page;
    }
    getTotalPages() {
        return this._meta?.total_pages || 0;
    }
    getPerPage() {
        return this._pageQuery.perPage;
    }
    getPage() {
        return this._objects;
    }
    setCurrentPage(page) {
        this._pageQuery.page = page;
        return this;
    }
    setPerPage(perPage) {
        this._pageQuery.perPage = perPage;
        return this;
    }
    setObjects(value) {
        this._objects = value;
        return this;
    }
    setMeta(value) {
        this._meta = value;
        return this;
    }
    getFrom() {
        return this.getPerPage() * (this.getCurrentPage() - 1) + 1;
    }
    getTo() {
        return this.getPerPage() * this.getCurrentPage();
    }
}
export class LocalPagination extends DefaultPagination {
    getPage() {
        return this._objects.slice((this.getCurrentPage() - 1) * this.getPerPage(), this.getCurrentPage() * this.getPerPage());
    }
}
